import Avatar from '@components/Avatar/Avatar';
import './company.scss';

export interface MuiAvatarProps {
    label?: string;
    src?: any;
}


const Company = ({ ...rest }: MuiAvatarProps) => {
    return (
        <div className='company-container'>
            <div className='logo'><Avatar {...rest}></Avatar></div>
            <div className="label">{rest?.label}</div>
        </div>
    )
}

export default Company